import React, { Fragment } from 'react';
import { Nav, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";


const HeaderLinks = (props) => {
  return (
    <div>
      <Nav pullRight>
        <Fragment>
          <LinkContainer to="/Home">
            <NavItem>Home</NavItem>
          </LinkContainer>
          <LinkContainer to="/contacts">
            <NavItem>Contacts</NavItem>
          </LinkContainer>
          <LinkContainer to="/events">
            <NavItem>Events</NavItem>
          </LinkContainer>
          <LinkContainer to="/timeline">
            <NavItem>Timeline</NavItem>
          </LinkContainer>
          <LinkContainer to="/settings">
            <NavItem>Settings</NavItem>
          </LinkContainer>
          <LinkContainer to="/logout">
            <NavItem onClick={props.clickedLogout}>Logout</NavItem>
          </LinkContainer>
        </Fragment>
      </Nav>
    </div>
  )
}

export default HeaderLinks;


// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.js